<template>
  <PrescriptionPage :config="config" />
</template>

<script>
import PrescriptionPage from '@/components/smallComponents/PrescriptionPage.vue'

export default {
  components: { PrescriptionPage },
  data() {
    return {
      config: {
        pageTitle: '处方信息',
        fetchApi: '/api/health/v2/prescription',
        fetchGroupedApi: '/api/health/v2/prescription/grouped',
        useGroupedApi: true,
        relRecordApi: '/api/health/v2/rela/record',
        replaceApi: '/api/health/v1/prescription/replace',
        replaceSubmitApi: '/api/health/v1/prescription/replace/submit',
        replaceResultApi: '/api/health/v1/prescription',
        showSymptoms: true,
        showGanZhi: true,
        tabs: ['开方信息', '针灸信息', '健康预测信息', '通用方信息'],
        showAiButtonOnAllTabs: true,
        showGenerateOnAllPrescriptionTabs: true,
        hasShanghanTab: true,
        showMainTabCard: false,
        generateRoute: '/prescriptionImage',
      },
    }
  },
}
</script>
